module.exports = __webpack_public_path__ + "img/U1F37A.245686ff.png";